module.exports = "/images/tag_80b5f2.png";